import React, { useEffect } from "react";
import { GiCalculator } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import Go from "../Go/Go";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import "../Blogs/Blog.css";
import Post from "./Post";

const blogData = [
  {
    id: 1,
    title: "Time Management",
    content: "Time Management for Financial and Tax Practices",
    image: "/mw.webp",
  },
  {
    id: 2,
    title: "Tax Advisory Services",
    content: "Why Tax Advisory is Crucial for Business Growth and Compliance",
    image: "lc.webp",
  },
  {
    id: 3,
    title: "Estate Planning",
    content: "The Importance of Professional Advice in Estate Planning",
    image: "/fl.webp",
  },
  {
    id: 4,
    title: "Corporate Finance",
    content: "Understanding Corporate Finance: Key Insights for Entrepreneurs",
    image: "rl.webp",
  },
];

const Blog = () => {
  const navigate = useNavigate();

  useEffect(() => {
    gsap.utils.toArray(".card-bb").forEach((card) => {
      gsap.fromTo(
        card,
        {
          transform: "perspective(500px) rotateX(0deg) scale(1)",
        },
        {
          scrollTrigger: {
            trigger: card,
            start: "top 80%",
            end: "bottom 20%",
            scrub: 0.5,
            markers: false, // Set to true to see the scroll trigger markers during testing
          },
          transform: (i) => {
            const rotateValue = i % 2 === 0 ? 15 : -15; // Positive for downward bend, negative for upward
            const scaleValue = 1 - Math.abs(rotateValue) * 0.01; // Slightly scale the card to enhance 3D effect
            return `perspective(500px) rotateX(${rotateValue}deg) scale(${scaleValue})`;
          },
          ease: "power3.out", // Smooth easing for the animation
        },
      );
    });

    gsap.to(".main-heading-pct", {
      scale: 2,
      duration: 2,
      ease: "power2.out",
      delay: 1.5,
      scrollTrigger: {
        trigger: ".full-blog",
        start: "top center",
        end: "bottom center",
        scrub: 1,
        toggleActions: "restart reverse restart reverse",
      },
    });
  }, []);

  const handleReadMore = (id) => {
    navigate(`/blog/${id}`);
  };

  return (
    <>
      <Post />

      <div className="full-blog">
        <div className="decorated-heading-pct">
          <GiCalculator className="react-icon-pct" />
        </div>
        <h1 className="main-heading-pct">Financial Insights</h1>
        <p className="description-pct">
          Dive into comprehensive articles curated by industry experts to keep
          you updated on the latest trends and changes in the financial and
          legal sectors. Our blogs cover everything from tax planning strategies
          to legal compliance, providing you with essential advice and detailed
          perspectives.
        </p>

        <div className="container-bb">
          {blogData.map((blog, index) => {
            const cardClass =
              index % 4 === 0
                ? "card-top-bb"
                : index % 4 === 1
                  ? "card-right-bb"
                  : index % 4 === 2
                    ? "card-bottom-bb"
                    : "card-left-bb";

            return (
              <div key={blog.id} className={`card-bb ${cardClass}`}>
                <div className="card-image-bb">
                  <img src={blog.image} alt={blog.title} />
                </div>
                <div className="card-text-bb">
                  <h3>{blog.title}</h3>
                  <p>{blog.content}</p>
                  <button
                    className="button-34"
                    onClick={() => handleReadMore(blog.id)}
                  >
                    Read More
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Go />
    </>
  );
};

export default Blog;
